import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { Input, Label, FormFeedback } from "reactstrap"

const NumberInput = ({ label, id, required, symbol }) => {
  const methods = useFormContext()
  const { control, formState } = methods
  const { errors } = formState

  return (
    <React.Fragment>
      <Label>{label}</Label>

      <Controller
        name={id}
        control={control}
        render={({ field }) => (
          <>
            {symbol ? (
              <div className="input-group">
                <div className="input-group-text">{symbol}</div>
                <Input
                  {...field}
                  id={id}
                  type="number"
                  required={required}
                  invalid={!!errors[id]}
                />
              </div>
            ) : (
              <Input
                {...field}
                id={id}
                type="number"
                required={required}
                invalid={!!errors[id]}
              />
            )}

            {errors[id]?.message ? (
              <FormFeedback type="invalid" className="d-block">
                {errors[id]?.message}
              </FormFeedback>
            ) : null}
          </>
        )}
      />
    </React.Fragment>
  )
}

NumberInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  required: PropTypes.bool,
}

export default NumberInput
